var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E6007A",
    d: "M14.571 6.214c0 .827-1.152 1.5-2.571 1.5s-2.572-.673-2.572-1.5s1.158-1.5 2.572-1.5s2.571.673 2.571 1.5m0 11.572c0 .827-1.152 1.5-2.571 1.5s-2.572-.673-2.572-1.5s1.158-1.5 2.572-1.5s2.571.673 2.571 1.5M8.293 9.92c.728-1.255.733-2.614.017-3.025c-.72-.416-1.886.27-2.614 1.526c-.729 1.255-.729 2.614-.018 3.025c.72.412 1.886-.27 2.615-1.525m10.02 2.628c.72.407.716 1.74-.009 2.974c-.728 1.234-1.898 1.903-2.614 1.496c-.724-.407-.72-1.74.004-2.975c.729-1.234 1.899-1.902 2.619-1.495m-9.999 4.478c.72-.407.716-1.74-.013-2.974c-.724-1.234-1.894-1.903-2.614-1.496c-.724.412-.72 1.74.009 2.974c.724 1.235 1.894 1.908 2.614 1.5zm9.999-8.601c.728 1.255.728 2.61.013 3.021c-.716.416-1.886-.265-2.615-1.525c-.72-1.256-.728-2.61-.013-3.022c.72-.416 1.886.266 2.615 1.526"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/dot.f368e9b01512c6657b301149e12e83cb.svg";
export { ForwardRef as ReactComponent };